import * as types from '../../constants/log/gemSocketUpdateLogConstants';

export const gemSocketUpdateLogListRequest = ({
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  nftUid,
  callback,
  error,
}) => ({
  type: types.GEM_SOCKET_UPDATE_LOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  nftUid,
  callback,
  error,
});
